module.exports = __webpack_public_path__ + "static/media/ServicesPref.625c76a1.png";